import moment from 'moment';
import 'moment-timezone';

const timeZone = 'America/Sao_Paulo';
const locale = 'pt-br';

class DateUtils {
  getMonthName(date) {
    const month = this.parseDate(date).locale(locale).format('MMMM');
    return month.charAt(0).toUpperCase() + month.slice(1); // capitalize month name
  }

  getDay(date) {
    return this.parseDate(date).format('DD');
  }

  getYear(date) {
    return this.parseDate(date).format('YYYY');
  }

  getFormattedDate(date) {
    return `${this.getDay(date)} de ${this.getMonthName(date)}`;
  }

  parseDate(datestring) {
    const date = moment(datestring);
    if (date.isValid()) {
      return date;
    }
    throw new Error('[DateUtils] Invalid date');
  }

  currentDate() {
    return moment().tz(timeZone).format('YYYY-MM-DD');
  }
}

export default new DateUtils();
